import { render, staticRenderFns } from "./AddKeyForBuilding.vue?vue&type=template&id=99fcd6de&"
import script from "./AddKeyForBuilding.vue?vue&type=script&lang=js&"
export * from "./AddKeyForBuilding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports